import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useT } from "@/context/LanguageContext";

const field = "w-full rounded-md border border-slate-200 px-4 py-3 text-sm outline-none focus:border-teal focus:ring-2 focus:ring-teal/30";

export function BookingScheduler({ date, time, onDate, onTime, refresh = 0 }) {
  const { t } = useT();
  const [slots, setSlots] = useState(null);
  const today = new Date().toISOString().slice(0, 10);

  useEffect(() => {
    if (!date) {
      setSlots(null);
      return;
    }
    setSlots(null);
    api.get("/bookings/slots", { params: { date } })
      .then((r) => setSlots(r.data.slots))
      .catch((e) => {
        console.error("Failed to load booking slots:", e);
        setSlots([]);
      });
  }, [date, refresh]);

  const available = (slots || []).filter((s) => s.available);

  return (
    <div className="space-y-3 rounded-lg border border-slate-200 bg-mist/50 p-4" data-testid="booking-scheduler">
      <label className="block text-xs font-semibold text-slate-500">{t("booking.pickDate")}</label>
      <input
        type="date"
        min={today}
        value={date || ""}
        onChange={(e) => { onDate(e.target.value); onTime(""); }}
        data-testid="booking-date"
        className={field}
      />
      {date && (
        <>
          <label className="block text-xs font-semibold text-slate-500">{t("booking.pickTime")}</label>
          {slots === null ? (
            <p className="text-xs text-slate-400">{t("booking.loadingSlots")}</p>
          ) : available.length === 0 ? (
            <p className="text-xs font-medium text-amber-600" data-testid="booking-no-slots">{t("booking.noSlots")}</p>
          ) : (
            <div className="flex flex-wrap gap-2" data-testid="booking-slots">
              {slots.map((s) => (
                <button
                  key={s.time}
                  type="button"
                  disabled={!s.available}
                  onClick={() => onTime(s.time)}
                  data-testid={`booking-slot-${s.time}`}
                  className={`rounded-md border px-4 py-2 text-sm font-semibold transition-colors ${
                    time === s.time
                      ? "border-ink bg-ink text-white"
                      : s.available
                      ? "border-slate-200 bg-white text-slate-700 hover:border-teal"
                      : "border-slate-100 bg-slate-50 text-slate-300 line-through"
                  }`}
                >
                  {s.time}
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
